import LoginModule from '@/modules/login';

export default LoginModule;
